import poiApi from '@/api/poi.api'

export const poiService = (function () {
  'use strict'

  /**
   * Devuelve los datos para la tabla del ABM de Grupos
   * @param {*} pageSize
   * @param {*} pageNumber
   * @param {*} headers
   */
  async function findAllPaginated(enterprises, pageSize, pageNumber, headers = false) {
    try {
      /*
      if (pageSize > 0 && pageNumber > 0) {
        const response = await poiApi.findAllPaginated(pageSize, pageNumber, headers)
        return response.data
      } else {
        return {
          data: [],
          headers: []
        }
      }
      */
      const response = await poiApi.findAllPaginated(enterprises, undefined, undefined, headers)
        return response.data
    } catch (exception) {
      console.log(exception)
      return []
    }
  }

  async function findAll(enterprises) {
    try {
      const response = await poiApi.findAll(enterprises)
      return response.data
    } catch (exception) {
      console.log(exception)
      return []
    }
  }

  /**
   * Devuelve el total de zonas de la collection para el paginador de la tabla del ABM
   */
  async function getTotal(enterprises) {
    try {
      const response = await poiApi.getTotal(enterprises)
      return response.data
    } catch (exception) {
      console.log(exception)
      return 0
    }
  }

  /**
   * Devuelve un zona con el id enviado como parámetro
   * @param {*} poiId
   */
  async function getPoi(poiId) {
    try {
        const response = await poiApi.getPoi(poiId)
        return response.data
    } catch (exception) {
        console.log(exception)
        return false
    }
  }

  /**
   * Para validar el nombre
   * Devuelve true si ya está asignado a un zona
   * @param {*} name
   */
  async function validatePoiName(name) {
    try {
      if (name) {
        const response = await poiApi.validatePoiName(name)
        return response.data
      } else {
        return false
      }
    } catch (exception) {
        console.log(exception)
        return false
    }
  }

  /**
   * Para eliminar un poi
   */
  async function deleteOne(id) {
    /*
    try {
        const response = await poiApi.deleteOne(id)
        return response.data
    } catch (exception) {
        console.log(exception)
        return null
    }
    */
    const response = await poiApi.deleteOne(id)
    return response.data
  }

  /**
   * Para eliminación múltiple
   */
  async function deleteMany(ids) {
    /*
    try {
        const response = await poiApi.deleteMany(ids)
        return response.data
    } catch (exception) {
        console.log(exception)
        return null
    }
    */
    const response = await poiApi.deleteMany(ids)
    return response.data
  }


  /**
   * Crea una nuevo zona en la collection
   * @param {*} poi
   */
  async function create(poi) {
    /*
    try {
      const response = await poiApi.create(poi, thingIds)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
    */
    const response = await poiApi.create(poi)
    return response.data
  }

  /**
   *  Actualiza un zona existente en la collection
   * @param {*} poi
   */
  async function update(poi) {
    /*
    try {
      const response = await poiApi.update(poi, thingIds)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
    */
    const response = await poiApi.update(poi)
    return response.data
  }

  async function getCategories(enterpriseId) {
    const response = await poiApi.getCategories(enterpriseId)
    return response.data
  }

  /**
   * Valida que para actualizar el valor "puntos de interes" del selector en ABM categorías no existan puntos de interes con dicha categoría 
   */
  async function validatePois(categoryId) {
    const response = await poiApi.validatePois(categoryId)
    return response.data
  }

  return {
    findAllPaginated,
    findAll,
    getTotal,
    getPoi,
    validatePoiName,
    deleteOne,
    deleteMany,
    create,
    update,
    getCategories,
    validatePois
  }
})()
